/**
 * DEFAULT_ANIMATION_MODE，供本模块相关规则使用。
 */
export const DEFAULT_ANIMATION_MODE = "swfclip" as const;

/**
 * AnimationMode 的数据结构或可选取值约定。
 */
export type AnimationMode = "ruffle" | "swfclip";
